import { render, staticRenderFns } from "./WineProductPage.vue?vue&type=template&id=ffaebf4e&scoped=true"
import script from "./WineProductPage.vue?vue&type=script&lang=js"
export * from "./WineProductPage.vue?vue&type=script&lang=js"
import style0 from "./WineProductPage.vue?vue&type=style&index=0&id=ffaebf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaebf4e",
  null
  
)

export default component.exports